<!-- src/App.vue -->
<template>
  <div>
    <!-- 方案2：简化结构（推荐） -->
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios';
import config from '@/config.js';


export default {
  name: 'App',
  setup() {
    const router = useRouter()
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    // 获取并设置网站图标和标题
    const fetchWebConfig = async () => {
      try {
        let storeId = null;

        // 方法1：从 URL 查询参数获取 store_id
        const urlParams = new URLSearchParams(window.location.search);
        storeId = urlParams.get('store_id');

        // 方法2：如果查询参数没有，从哈希参数获取
        if (!storeId) {
          const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
          storeId = hashParams.get('store_id');
        }

        console.log('获取到的 store_id:', storeId); // 调试用

        const response = await axios.get(`${config.BASE_URL}/pc/api/web_icon.php`, {
          params: {
            store_id: storeId
          }
        });

        if (response.data.success) {
          const { pc_title, pc_ico } = response.data.data

          // 设置浏览器标题
          document.title = pc_title || '智能名片商业版'

          // 设置浏览器图标
          const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
          favicon.type = 'image/x-icon'
          favicon.rel = 'shortcut icon'
          favicon.href = pc_ico
          document.getElementsByTagName('head')[0].appendChild(favicon)
        }
      } catch (error) {
        console.error('获取网站配置失败:', error)
        // 设置默认标题
        document.title = '智能名片商业版'
      }
    }

    const checkLoginStatus = () => {
      isLoggedIn.value = !!Cookies.get('user_token')
    }

    setInterval(checkLoginStatus, 300)

    watch(
      () => Cookies.get('user_token'),
      (newValue) => {
        isLoggedIn.value = !!newValue
      }
    )

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        Cookies.remove('pc_user_token')
        Cookies.remove('pc_user_info')
        isLoggedIn.value = false

        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    // 在组件挂载时获取配置
    onMounted(() => {
      fetchWebConfig()
    })

    return {
      isLoggedIn,
      handleLogout
    }
  }
}
</script>

<style>
/* 全局背景样式 - 改为深空黑金主题 */
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
  background: linear-gradient(135deg,
      #0a0a0a 0%,
      #1a1a1a 25%,
      #2d2d2d 50%,
      #1f1f1f 75%,
      #121212 100%);
  position: relative;
  overflow-x: hidden;
}

/* 科技感背景效果 - 改为金色系 */
.main-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(212, 175, 55, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(184, 134, 11, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(218, 165, 32, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* 网格背景 - 改为金色 */
.main-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(212, 175, 55, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(212, 175, 55, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 0;
}

/* 全局按钮样式 */
.el-button {
  border-radius: 8px !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
}

.el-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent);
  transition: left 0.6s ease;
}

.el-button:hover::before {
  left: 100%;
}

/* 主要按钮样式 - 改为金色渐变 */
.el-button--primary {
  background: linear-gradient(135deg, #d4af37 0%, #f4d03f 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3) !important;
}

.el-button--primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4) !important;
}

/* 成功按钮样式 - 改为翡翠绿 */
.el-button--success {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3) !important;
}

.el-button--success:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(39, 174, 96, 0.4) !important;
}

/* 警告按钮样式 */
.el-button--warning {
  background: linear-gradient(135deg, #e67e22 0%, #f39c12 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(230, 126, 34, 0.3) !important;
}

.el-button--warning:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(230, 126, 34, 0.4) !important;
}

/* 危险按钮样式 */
.el-button--danger {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3) !important;
}

.el-button--danger:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4) !important;
}

/* 信息按钮样式 */
.el-button--info {
  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(149, 165, 166, 0.3) !important;
}

.el-button--info:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(149, 165, 166, 0.4) !important;
}

/* 全局输入框样式 - 边框改为金色 */
.el-input {
  --el-input-bg-color: rgba(255, 255, 255, 0.08);
  --el-input-border-color: rgba(212, 175, 55, 0.3);
  --el-input-hover-border-color: #d4af37;
  --el-input-focus-border-color: #d4af37;
}

.el-input__wrapper {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(212, 175, 55, 0.3) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
}

.el-input__wrapper:hover {
  border-color: #d4af37 !important;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2) !important;
}

.el-input__wrapper.is-focus {
  border-color: #d4af37 !important;
  box-shadow: 0 4px 20px rgba(212, 175, 55, 0.3) !important;
}


.el-input__inner::placeholder {
  color: #b0b8c8 !important;
}

/* 文本域样式 */
.el-textarea__inner {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(212, 175, 55, 0.3) !important;
  border-radius: 8px !important;
  color: #000000 !important;
  transition: all 0.3s ease !important;
}

.el-textarea__inner:hover {
  border-color: #d4af37 !important;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2) !important;
}

.el-textarea__inner:focus {
  border-color: #d4af37 !important;
  box-shadow: 0 4px 20px rgba(212, 175, 55, 0.3) !important;
}

/* 选择器样式 */
.el-select .el-input__wrapper {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(10px);
}

/* 下拉菜单样式 */
.el-select-dropdown {
  background: rgba(26, 26, 26, 0.95) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(212, 175, 55, 0.3) !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4) !important;
}

.el-select-dropdown__item {
  color: #e0e6ff !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(212, 175, 55, 0.1) !important;
}

.el-select-dropdown__item.selected {
  color: #d4af37 !important;
  background: rgba(212, 175, 55, 0.08) !important;
}

/* 确保路由内容在背景之上 */
.router-view-content {
  position: relative;
  z-index: 1;
}

.upload-tip {
  font-size: 12px;
  color: #a0a8b8 !important;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}

/* 自定义滚动条 - 改为金色 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #d4af37 0%, #f4d03f 100%);
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

/* 全局弹窗样式优化 */
.el-dialog {
  max-height: 85vh !important;
  display: flex !important;
  flex-direction: column !important;
  margin: 5vh auto !important;

  .el-dialog__header {
    flex-shrink: 0;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-dialog__body {
    flex: 1;
    overflow-y: auto !important;
    max-height: calc(85vh - 130px) !important;
    padding: 20px !important;

    /* 优化滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c0c4cc;
      border-radius: 3px;

      &:hover {
        background: #909399;
      }
    }
  }

  .el-dialog__footer {
    flex-shrink: 0;
    border-top: 1px solid #e4e7ed;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95% !important;
    max-height: 90vh !important;
    margin: 2vh auto !important;

    .el-dialog__body {
      max-height: calc(90vh - 120px) !important;
    }
  }
}

/* 替换你现有的滚动条相关样式 */
html {
  overflow-y: scroll;
}

body {
  overflow-y: visible;
  margin: 0;
  padding: 0;
}
</style>

<style scoped>
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}
</style>